export default __webpack_public_path__ + "static/media/ok-flower.e2f30f9e.png";